import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { ChecklistStatus } from '../../shared/checklistUtils';
import type { TaxesPaymentsField } from '../../tabs/taxesPayments/types';

interface TaxesPaymentsRuleText {
  field: TaxesPaymentsField;
  rule: string;
  summary: Record<ChecklistStatus, string>;
}

export const TAXES_PAYMENTS_RULE_TEXT: Record<CmChecklist.TaxesPaymentsRuleId, TaxesPaymentsRuleText> = {
  'city-tax-payable-direct': {
    field: 'City/Other Tax Payable Direct',
    rule: 'If City/Other Tax Payable Direct is marked Yes, the tax details field must be populated before approval.',
    summary: {
      approved: 'City/Other Tax Payable Direct details are complete.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'City/Other Tax Payable Direct needs tax detail comments before approval.',
    },
  },
  'per-room-city-taxes': {
    field: 'Per-room city taxes in Admin Portal',
    rule: 'If per-room city taxes are payable directly to the property, they must be loaded in the Admin Portal before the offer goes live.',
    summary: {
      approved: 'Per-room city taxes are correctly reflected in the Admin Portal.',
      blocked: 'Opportunity or property data is unavailable to verify this rule.',
      'requires approval': 'Per-room city taxes need to be loaded in the Admin Portal.',
    },
  },
  'payment-mechanism-milestone': {
    field: 'Payment mechanism and milestone rules',
    rule: 'Both payment method and milestone rules must be populated, and milestone percentages must sum to 100%.',
    summary: {
      approved: 'Payment method and milestone rules are complete and sum to 100%.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'Payment method and milestone rules need review.',
    },
  },
  'prize-used': {
    field: 'Prize / Prize Used',
    rule: 'If a prize order ID is present, the offer requires CM team approval before going live.',
    summary: {
      approved: 'No prize order requiring additional CM approval.',
      blocked: 'Opportunity data is unavailable to verify this rule.',
      'requires approval': 'Prize order present — CM team approval required.',
    },
  },
};
